import React, { Component } from 'react';
import { Formik } from 'formik';
import { Space, Button, Form, Alert } from "antd";
import * as Yup from 'yup';
import { find } from 'lodash';
import * as constants from '../../constants';

import common from '../../../../common';
import core from '../../../core';


const { TextInput, SelectInput, MultiSelectInput, DisplayFormikState } = core;

const FormItem = Form.Item;

const FormSchema = Yup.object().shape({
    idLegalGround: Yup.array().min(1).required('*'),
});

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 18 },
}

const tailFormItemLayout = {
    wrapperCol: {
        xs: {
            span: 24,
            offset: 0,
        },
        sm: {
            span: 14,
            offset: 4,
        },
    },
};

class LegalGroundForm extends Component {

    onSave = async (values, { setSubmitting, setErrors }) => {
        if (this.props.onSave) {
            
            let lg = [];
            let count = -1;
            let idProcessingActivity = this.props.datacontext.idProcessingActivity;
            if(values.idLegalGround){
                values.idLegalGround.forEach(i => {
                    let legalground = find(this.props.picklists.legalGrounds, { 'id': i });
                    lg.push({ id: count, idProcessingActivity: idProcessingActivity, idLegalGround : legalground.id, legalGroundName: legalground.name  })
                    count--;
                })
            }

            await this.props.onSave(lg);
            setSubmitting(false);
        } else {
            setSubmitting(false)
        }
    }
    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LegalGroundForm', key);
    }

    CreateForm = (props) => {
        //console.log(props);
        const userHasReadonlyRights = false; //!this.props.currentUsersCompanyRights.includes(common.rights.BedrijfMuteren);

        return (
            <Form layout='horizontal' style={{ margin: 10 }}>
                <MultiSelectInput {...props} name="idLegalGround" label={this.label("LegalGrounds")} formItemLayout={formItemLayout}
                             nameField="name" idField="id" items={this.props.picklists.legalGrounds} placeholder={this.label("DdlPlaceholder")} />
                
                <FormItem {...tailFormItemLayout}>
                    <Space.Compact className='entity-form-btns'>
                        <Button disabled={props.isSubmitting || userHasReadonlyRights} onClick={this.props.onCancel}>{this.label("Cancel")} </Button>
                        <Button type="primary" onClick={() => props.handleSubmit()} disabled={props.isSubmitting || userHasReadonlyRights} > {this.label("Save")} </Button>
                    </Space.Compact>
                </FormItem>
                {props.isSubmitting &&
                    <Alert
                        message={this.label("Saving")}
                        style={{ marginTop: 20 }}
                    />
                }
                {/* <DisplayFormikState {...props} /> */}
            </Form>
        )
    }

    render() {
        return (
            <Formik enableReinitialize={true}
                initialValues={this.props.datacontext}
                validationSchema={FormSchema}
                onSubmit={this.onSave}
                render={this.CreateForm}
                innerRef={p => (this.formik = p)}
            />
        );
    }
}

export default LegalGroundForm